import { createApi } from '@reduxjs/toolkit/query/react';

import { ApiResponse } from '../../model';
import { API_CONSTANTS } from '../../utils/constants';

import type {
  NotificationCountResponse,
  NotificationListResponse,
} from './model';
import { baseQueryWithReauth } from '../../apis/baseQuery';

export const notificationsApi = createApi({
  reducerPath: 'notificationsApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['Notifications', 'NotificationCount'],
  endpoints: (build) => ({
    getAdminNotifications: build.query<
      ApiResponse<NotificationListResponse>,
      {
        page?: number;
        limit?: number;
        sortBy?: string;
        sortDirection?: 'asc' | 'desc';
      } | void
    >({
      query: (params = {}) => ({
        url: API_CONSTANTS.ADMIN_NOTIFICATIONS.LIST_URL,
        method: 'GET',
        params,
      }),
      providesTags: ['Notifications'],
    }),
    getAdminNotificationCount: build.query<
      ApiResponse<NotificationCountResponse>,
      void
    >({
      query: () => ({
        url: API_CONSTANTS.ADMIN_NOTIFICATIONS.COUNT_URL,
        method: 'GET',
      }),
      providesTags: ['NotificationCount'],
    }),
    markNotificationAsRead: build.mutation<
      ApiResponse<unknown>,
      string | number
    >({
      query: (notificationId) => ({
        url: `api/v1/admin-notifications/${notificationId}/mark-as-read`,
        method: 'PUT',
      }),
      invalidatesTags: ['Notifications', 'NotificationCount'],
    }),
    markAllNotificationsAsRead: build.mutation<
      ApiResponse<{ updated: number }>,
      void
    >({
      query: () => ({
        url: API_CONSTANTS.ADMIN_NOTIFICATIONS.MARK_ALL_READ_URL,
        method: 'PUT',
      }),
      invalidatesTags: ['Notifications', 'NotificationCount'],
    }),
  }),
});

export const {
  useGetAdminNotificationsQuery,
  useGetAdminNotificationCountQuery,
  useLazyGetAdminNotificationsQuery,
  useMarkNotificationAsReadMutation,
  useMarkAllNotificationsAsReadMutation,
} = notificationsApi;
export default notificationsApi;
